import {Component, Output, EventEmitter, Input} from '@angular/core';
import * as sanitizeHtml from 'sanitize-html';

import { Rule } from '../services/capd.model';

@Component({
  selector: 'company-nr-message-editor',
  templateUrl: './company-nr-message-editor.component.html',
  inputs: ['rule']
})

/**
 * Component for editing NoteReader messages.
 */
export class CompanyNrMessageEditorComponent {

  @Output() changed: EventEmitter<any> = new EventEmitter();
  @Input() rule: Rule;

  ngOnInit() {
    if(this.rule.action.groups.length == 0) {
      // if the actionGroups do not exist, set empty defaults for the html to use
      this.rule.action.groups[0] = {type: "", messageText: "", options: [""]}
      this.rule.action.groups[1] = {type: "", messageText: "", options: [""]}
    }
  }

  /**
   * Adds an additional option to the end of the list of suggestions.
   *
   * @func addListOption
   */
  addListOption() {
    if (this.rule.action.groups[1].options.length < 6) {
      const newOption = new Object({name: '', message: '', code: '', codeType: 'Snomed'});
      this.rule.action.groups[1].options.push(newOption);
    }
  }

  /**
   * Removes an option from the list.
   *
   * @func removeListOption
   * @param {ActionGroup} option - the option to remove.
   */
  removeListOption(option) {
    this.rule.action.groups[1].options.splice(this.rule.action.groups[1].options.indexOf(option), 1);
  }

  sanitizeHtml(inputText) {
    return sanitizeHtml(inputText,  {
      allowedTags: [ 'b', 'i', 'em', 'strong', 'a', "aside", "footer", "header", "h1", "h2", "h3", "h4",
        "h5", "h6", "div", "caption", "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead",
        "tr", "li", "main", "ol", "p", "pre", "ul", "br", "u"],
      allowedAttributes: {
        'a': [ 'href', 'name', 'target' ]
      },
      disallowedTagsMode: 'discard',
      selfClosing: ['br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
      allowedSchemes: [ 'http', 'https', 'ftp', 'mailto', 'tel' ],
      allowedSchemesByTag: {},
      allowedSchemesAppliedToAttributes: [ 'href', 'src', 'cite' ],
      allowProtocolRelative: true,
      enforceHtmlBoundary: false
    });
  }

  // Replace & " < > '
  encodeHTML(inputText) {
    return inputText.replace(/&/g,'&amp;')
        .replace(/"/i,'&quot;')
        .replace(/</i, '&lt;')
        .replace(/>/i,'&gt;')
        .replace(/'/i,'&apos;');
  }

  encodeImage(inputText) {
    return inputText.replace(/<img/i, '&lt;img')
        .replace(/<\/img>/i, '&lt;img&gt;');
  }

  encodeAlert(inputText) {
    return inputText.replace(/alert\(/i, ' ');
  }
}
